import {SectionHeader} from "./SectionHeader";

const TEAM = [
    {
        initials: "GW",
        name: "Praxisinhaberin Gabriele Wagner",
        role: "Fachärztin für Allgemeinmedizin, Notfallmedizin und Naturheilverfahren",
        bio: "Über 20 Jahre Erfahrung in der hausärztlichen Versorgung"
    },
    {
        initials: "CW",
        name: "Christiana Wirth",
        role: "Medizinische Fachangestellte",
        bio: "Seit über 20 Jahren ein Team"
    },
];

export function Team() {
    return (
        <section id="team" className="section">
            <SectionHeader title="Unser Team"/>
            <div className="team-grid">
                {TEAM.map(({initials, name, role, bio}) => (
                    <div className="team-member" key={name}>
                        <div className="avatar">{initials}</div>
                        <div className="member-info">
                            <h3>{name}</h3>
                            <div className="member-role">{role}</div>
                            <p className="member-bio">{bio}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}